// Assistentus API helper for AssistentusApp
// Uses nginx proxy (/api/) when served from assistentus subdomain,
// or falls back to config-based URL when embedded in shell federation.
import config from './config';

const API_BASE = config.ASSISTENTUS_API_URL;

export const getApiUrl = (path: string): string => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${API_BASE}${normalizedPath}`;
};
